import { TradeRequestItem } from 'data/models/TradeRequest';
import { RootState } from 'data/store';

export const selectTradeRequests = (state: RootState): TradeRequestItem[] =>
  state.tradeRequests.tradeRequests;

export const selectTradeRequestsIsLoading = (state: RootState): boolean =>
  state.tradeRequests.isLoading;
